import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Field, Input, Textarea, UploadBox } from '@/components';
import { RouteKeys } from '@/configs';
import { MediaType } from '@/types';
import { useBoolean } from '@/utils';
import classnames from 'classnames';
import { useAtom } from 'jotai';
import { useAtomValue } from 'jotai/utils';
import { useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { boxIdAtom, chainAtom, descriptionFullfilledAtom, formDataAtom, isEdittingAtom, newActivity, useBindFormField, useUpdateFormField, } from './atoms';
import styles from './index.module.less';
import { useLocales } from './useLocales';
export const Description = () => {
    const t = useLocales();
    const isEditting = useAtomValue(isEdittingAtom);
    const chain = useAtomValue(chainAtom);
    const boxId = useAtomValue(boxIdAtom);
    const fullfilled = useAtomValue(descriptionFullfilledAtom);
    const history = useHistory();
    const [formData, setFormData] = useAtom(formDataAtom);
    const bindField = useBindFormField();
    const updateField = useUpdateFormField();
    const updateActivityAt = (index, updater) => {
        setFormData((fd) => ({
            ...fd,
            activities: fd.activities.map((act, idx) => (idx === index ? updater(act) : act)),
        }));
    };
    const appendActivity = () => {
        setFormData((fd) => ({
            ...fd,
            activities: [...fd.activities, newActivity()],
        }));
    };
    const deleteLastActivity = () => {
        setFormData((fd) => {
            const copy = [...fd.activities];
            copy.pop();
            return {
                ...fd,
                activities: copy,
            };
        });
    };
    const [uploading, setUploading, setNotUploading] = useBoolean();
    const handleUploaded = useCallback(({ url: mediaUrl, mediaType }) => {
        setUploadError(null);
        setNotUploading();
        setFormData((fd) => ({ ...fd, mediaUrl, mediaType }));
    }, []);
    const [uploadError, setUploadError] = useState(null);
    return (_jsxs("section", { className: styles.section, children: [_jsxs("h2", { className: styles.sectionTitle, children: [t('Description'), _jsx("span", { className: styles.step, children: "1/2" })] }), _jsx(Field, { className: styles.field, name: t('MaskBox name'), required: true, children: _jsx(Input, { placeholder: t('eg. Punk & Mask Special Edition'), fullWidth: true, size: "large", value: formData.name, onChange: bindField('name') }) }), _jsxs(Field, { className: classnames(styles.field, styles.mediaField), name: t('Mystery thumbnail'), tip: t('Recommendation: 480*320/960*640'), required: true, children: [_jsx(UploadBox, { mediaUrl: formData.mediaUrl, mediaType: formData.mediaType, tabIndex: 0, onStartUpload: setUploading, onUploaded: handleUploaded, onError: setUploadError }), uploadError ? _jsx("div", { className: styles.error, children: uploadError.message }) : null, formData.mediaUrl ? (_jsx(Button, { colorScheme: "danger", size: "small", className: styles.mediaRestButton, onClick: () => {
                            setUploadError(null);
                            updateField('mediaUrl', '');
                            updateField('mediaType', MediaType.Unknown);
                        }, children: t('Reset') })) : null] }), formData.activities.map((activity, index, list) => (_jsxs(Field, { className: styles.field, name: `${t('Activity description')} ${list.length > 1 ? index + 1 : ''}`, children: [_jsx(Input, { placeholder: t('eg.Rule Introduction'), fullWidth: true, size: "large", value: activity.title, onChange: (evt) => {
                            const newValue = evt.currentTarget.value;
                            updateActivityAt(index, (act) => ({ ...act, title: newValue }));
                        } }), _jsx(Textarea, { className: styles.cell, placeholder: t('Write Something..'), value: activity.body, onChange: (evt) => {
                            const newValue = evt.currentTarget.value;
                            updateActivityAt(index, (act) => ({ ...act, body: newValue }));
                        } })] }, index))), _jsx("div", { className: styles.field, children: _jsxs("div", { className: styles.buttonGroup, children: [_jsx(Button, { className: styles.button, colorScheme: "primary", size: "large", onClick: appendActivity, children: t('Add') }), formData.activities.length > 3 && (_jsx(Button, { className: styles.button, colorScheme: "danger", size: "large", onClick: deleteLastActivity, children: t('Delete') }))] }) }), _jsx("div", { className: styles.field, children: _jsx(Button, { fullWidth: true, disabled: !fullfilled || uploading, colorScheme: "primary", size: "large", onClick: () => {
                        const search = isEditting ? `?chain=${chain}&box=${boxId}` : '';
                        history.replace(`${RouteKeys.EditMeta}${search}`);
                    }, children: uploading ? t('Uploading thumbnail...') : t('Next') }) })] }));
};
